import React, { useState } from "react";
import { useQueries } from "@tanstack/react-query";

import axios from "axios";

import Slider from "react-slick";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { MenuItem } from "../../components";

import dayjs from "dayjs";
import { weekNumber } from "weeknumber";
import moment from "moment";

import { jsPDF } from "jspdf";
import "../Fonts/Parisienne-normal.js";
import "../Fonts/OpenSans-normal";

import "./SliderMenu.css";

const SliderMenu = () => {
  const [viewNext, setViewNext] = useState(false);

  const dow = new Date();
  let year = dow.getFullYear();
  let week = weekNumber(dow);
  let day = dow.getDay();

  //next week
  const nextWeekDate = dayjs(moment().startOf("isoWeek").add(7, "d"));
  let nextYear = dayjs(nextWeekDate).format("YYYY");
  const ndow = new Date(nextWeekDate);
  let nextWeek = weekNumber(ndow);

  let isData = false;
  let isDataNext = false;

  const [menu, nextMenu, price] = useQueries({
    queries: [
      {
        queryKey: ["thisWeek"],
        queryFn: () =>
          axios
            .get(
              `https://muszalyvendeglo.herokuapp.com/getMenuByDate?year=${year}&week=${week}`
            )
            .then((res) => res.data),
      },

      {
        queryKey: ["nextWeek"],
        queryFn: () =>
          axios
            .get(
              `https://muszalyvendeglo.herokuapp.com/getMenuByDate?year=${nextYear}&week=${nextWeek}`
            )
            .then((res) => res.data),
      },
      {
        queryKey: ["price"],
        queryFn: () =>
          axios
            .get(`https://muszalyvendeglo.herokuapp.com/getPrice`)
            .then((res) => res.data),
      },
    ],
  });

  menu.data === "" ? (isData = false) : (isData = true);
  nextMenu.data === "" ? (isDataNext = false) : (isDataNext = true);

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    initialSlide: day - 1,
    slidesToShow: 3,
    centerPadding: 0,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          initialSlide: day - 2,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1920,
        settings: {
          initialSlide: day - 2,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          initialSlide: day - 1,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          initialSlide: day - 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          initialSlide: day - 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };

  const pdfGenerate = () => {
    var doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
    });

    var imgData =
      "data:image/png;base64,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";

    doc.setLineWidth(1);
    doc.line(75, 15, 98, 15);
    doc.line(80, 17, 98, 17);
    doc.addImage(imgData, 100, 10, 10, 10);
    doc.line(112, 15, 135, 15);
    doc.line(112, 17, 130, 17);

    doc.setFont("Parisienne");
    doc.setFontSize(36);
    doc.text("Muszály", 105, 30, null, null, "center");

    doc.line(75, 40, 92, 40);
    doc.line(80, 42, 92, 42);

    doc.setFont("OpenSans");
    doc.setFontSize(14);
    doc.text("vendéglő", 105, 42, null, null, "center");

    doc.line(118, 40, 135, 40);
    doc.line(118, 42, 130, 42);

    doc.setFontSize(14);
    doc.text(nextMenu.data?.dateRange, 10, 60);
    doc.text("Napi ajánlatunk ára:", 200, 60, null, null, "right");

    doc.setFontSize(18);
    doc.text(price?.data[0].price + " Ft", 200, 67, null, null, "right");

    doc.setFontSize(13);
    doc.setLineWidth(0.5);

    //hétfő
    doc.text("HÉTFŐ", 10, 85);
    doc.line(10, 86, 24, 86);

    doc.text(nextMenu.data?.dailyMenu1?.soup, 43, 85);
    doc.text(nextMenu.data?.dailyMenu1?.menuA, 43, 92);
    doc.text(nextMenu.data?.dailyMenu1?.menuB, 43, 99);
    doc.text(nextMenu.data?.dailyMenu1?.menuC, 43, 106);

    //kedd
    doc.text("KEDD", 10, 122);
    doc.line(10, 123, 22, 123);

    doc.text(nextMenu.data?.dailyMenu2?.soup, 43, 122);
    doc.text(nextMenu.data?.dailyMenu2?.menuA, 43, 130);
    doc.text(nextMenu.data?.dailyMenu2?.menuB, 43, 137);
    doc.text(nextMenu.data?.dailyMenu2?.menuC, 43, 144);

    //szerda
    doc.text("SZERDA", 10, 161);
    doc.line(10, 162, 27, 162);

    doc.text(nextMenu.data?.dailyMenu3?.soup, 43, 161);
    doc.text(nextMenu.data?.dailyMenu3?.menuA, 43, 168);
    doc.text(nextMenu.data?.dailyMenu3?.menuB, 43, 175);
    doc.text(nextMenu.data?.dailyMenu3?.menuC, 43, 182);

    //csütörtök
    doc.text("CSÜTÖRTÖK", 10, 199);
    doc.line(10, 200, 36, 200);

    doc.text(nextMenu.data?.dailyMenu4?.soup, 43, 199);
    doc.text(nextMenu.data?.dailyMenu4?.menuA, 43, 206);
    doc.text(nextMenu.data?.dailyMenu4?.menuB, 43, 213);
    doc.text(nextMenu.data?.dailyMenu4?.menuC, 43, 220);

    //péntek
    doc.text("PÉNTEK", 10, 237);
    doc.line(10, 238, 27, 238);

    doc.text(nextMenu.data?.dailyMenu5?.soup, 43, 237);
    doc.text(nextMenu.data?.dailyMenu5?.menuA, 43, 244);
    doc.text(nextMenu.data?.dailyMenu5?.menuB, 43, 251);
    doc.text(nextMenu.data?.dailyMenu5?.menuC, 43, 258);

    doc.setFontSize(10);
    doc.text(
      "Éttermünk a napi ajánlat változtatásának jogát fenntartja!",
      10,
      280
    );
    doc.text(
      "Az étel elkészítését követően 3 órán belül fogyasztandó,",
      10,
      285
    );
    doc.text("utána hőkezelést igényel.", 10, 290);

    doc.setFontSize(11);
    doc.text("http://www.muszalyvendeglo.hu", 200, 280, null, null, "right");
    doc.text("Telefon: 76/323-185", 200, 285, null, null, "right");
    doc.text("Kecskemét, Újerdő u. 27", 200, 290, null, null, "right");

    // var string = doc.output("datauristring");
    // var embed = "<embed width='100%' height='100%' src='" + string + "'/>";
    // var x = window.open();
    // x.document.open();
    // x.document.write(embed);
    // x.document.close();

    doc.save("muszályvendéglő.hu.pdf");
  };

  return (
    <div className="app__bg section__padding app__slider" id="menu">
      <div>
        <h1 className="app__header-h1 app__slider-h1">Heti étlap</h1>
      </div>
      {isData && (
        <div className="app__slider__container">
          <Slider {...settings}>
            <MenuItem
              day={menu.data?.dailyMenu1?.day}
              date={menu.data?.dailyMenu1?.date}
              soup={menu.data?.dailyMenu1?.soup}
              menuA={menu.data?.dailyMenu1?.menuA}
              menuB={menu.data?.dailyMenu1?.menuB}
              menuC={menu.data?.dailyMenu1?.menuC}
            />
            <MenuItem
              day={menu.data?.dailyMenu2?.day}
              date={menu.data?.dailyMenu2?.date}
              soup={menu.data?.dailyMenu2?.soup}
              menuA={menu.data?.dailyMenu2?.menuA}
              menuB={menu.data?.dailyMenu2?.menuB}
              menuC={menu.data?.dailyMenu2?.menuC}
            />
            <MenuItem
              day={menu.data?.dailyMenu3?.day}
              date={menu.data?.dailyMenu3?.date}
              soup={menu.data?.dailyMenu3?.soup}
              menuA={menu.data?.dailyMenu3?.menuA}
              menuB={menu.data?.dailyMenu3?.menuB}
              menuC={menu.data?.dailyMenu3?.menuC}
            />
            <MenuItem
              day={menu.data?.dailyMenu4?.day}
              date={menu.data?.dailyMenu4?.date}
              soup={menu.data?.dailyMenu4?.soup}
              menuA={menu.data?.dailyMenu4?.menuA}
              menuB={menu.data?.dailyMenu4?.menuB}
              menuC={menu.data?.dailyMenu4?.menuC}
            />
            <MenuItem
              day={menu.data?.dailyMenu5?.day}
              date={menu.data?.dailyMenu5?.date}
              soup={menu.data?.dailyMenu5?.soup}
              menuA={menu.data?.dailyMenu5?.menuA}
              menuB={menu.data?.dailyMenu5?.menuB}
              menuC={menu.data?.dailyMenu5?.menuC}
            />
          </Slider>
        </div>
      )}
      {!isData && (
        <div className="missingMenu">
          <h1 className="missingText">A heti menü feltöltés alatt!</h1>
        </div>
      )}
      {isDataNext && (
        <Box className="buttonContainer">
          <Button
            className="menuDownload"
            onClick={pdfGenerate}
            endIcon={<FileDownloadIcon />}
          >
            jövő heti menü
          </Button>
        </Box>
      )}
    </div>
  );
};

export default SliderMenu;
